export const formatCpr = (cpr: string | number): string => {
    const digits = String(cpr ?? '')
        .replace(/\D/g, '')
        .slice(0, 10);

    if (digits.length > 6) {
        return `${digits.slice(0, 6)}-${digits.slice(6)}`.slice(0, 11);
    }

    return digits;
};
